module.exports = __webpack_public_path__ + "static/img/SI.99fab1cc.svg";